var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    {
      staticClass:
        "d-flex justify-content-between border__top border__color--gray cart-product",
    },
    [
      _c("div", { staticClass: "d-flex align-items-center" }, [
        _c("img", {
          staticClass: "cart-product__image",
          attrs: { src: _vm.item.thumb, alt: "cart image" + _vm.item.name },
        }),
        _vm._v(" "),
        _c("div", [
          _c(
            "p",
            {
              staticClass:
                "cart-product__name font__family--gotham font__weight--medium font__color--gray mb-1",
            },
            [_vm._v("\n                " + _vm._s(_vm.item.name))]
          ),
          _vm._v(" "),
          _c("div", { staticClass: "d-flex align-items-center" }, [
            _c(
              "span",
              {
                staticClass:
                  "cart-product__quantity font__family--gotham font__weight--light font__color--gray pr-1",
              },
              [_vm._v(_vm._s(_vm.$t("quantity", "cart")) + ":")]
            ),
            _vm._v(" "),
            _c(
              "div",
              {
                staticClass:
                  "counter-box--smaller d-inline-block position-relative",
              },
              [
                _c("p", { staticClass: "counter-box--smaller__arrows mb-0" }, [
                  _c("span", {
                    staticClass:
                      "plus counter-box--smaller__arrow counter-box--smaller__arrow__next",
                    on: {
                      click: function ($event) {
                        return _vm.getMoreQuantity()
                      },
                    },
                  }),
                  _vm._v(" "),
                  _c("span", {
                    staticClass:
                      "minus counter-box--smaller__arrow counter-box--smaller__arrow__prev",
                    on: {
                      click: function ($event) {
                        return _vm.getLessQuantity()
                      },
                    },
                  }),
                ]),
                _vm._v(" "),
                _c("input", {
                  directives: [
                    {
                      name: "model",
                      rawName: "v-model",
                      value: _vm.item.quantity,
                      expression: "item.quantity",
                    },
                  ],
                  staticClass: "counter-box--smaller__input",
                  attrs: { type: "text" },
                  domProps: { value: _vm.item.quantity },
                  on: {
                    input: [
                      function ($event) {
                        if ($event.target.composing) return
                        _vm.$set(_vm.item, "quantity", $event.target.value)
                      },
                      function ($event) {
                        return _vm.setCartProductQuantity($event)
                      },
                    ],
                  },
                }),
              ]
            ),
          ]),
        ]),
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "d-flex flex-column justify-content-between" }, [
        _c(
          "a",
          {
            staticClass: "text-right",
            attrs: { href: "#" },
            on: {
              click: function ($event) {
                $event.preventDefault()
                return _vm.removeFromCart()
              },
            },
          },
          [
            _c(
              "svg",
              {
                staticClass: "cart-product__remove",
                attrs: {
                  width: "16px",
                  height: "16px",
                  viewBox: "0 0 16 16",
                  version: "1.1",
                  xmlns: "http://www.w3.org/2000/svg",
                  "xmlns:xlink": "http://www.w3.org/1999/xlink",
                },
              },
              [
                _c("title", [_vm._v("7761595A-79BC-4696-9D3B-F79F423E42FD")]),
                _vm._v(" "),
                _c("desc", [_vm._v("Created with sketchtool.")]),
                _vm._v(" "),
                _c(
                  "g",
                  {
                    attrs: {
                      id: "desktop_design",
                      stroke: "none",
                      "stroke-width": "1",
                      fill: "none",
                      "fill-rule": "evenodd",
                      "stroke-linecap": "round",
                      "stroke-linejoin": "round",
                    },
                  },
                  [
                    _c(
                      "g",
                      {
                        attrs: {
                          id: "cart",
                          transform: "translate(-512.000000, -28.000000)",
                          stroke: "#93999C",
                          "stroke-width": "1.4",
                        },
                      },
                      [
                        _c(
                          "g",
                          {
                            attrs: {
                              id: "icon/closeGrey",
                              transform: "translate(513.000000, 29.000000)",
                            },
                          },
                          [
                            _c("line", {
                              attrs: {
                                x1: "14",
                                y1: "0",
                                x2: "0",
                                y2: "14",
                                id: "Stroke-429",
                              },
                            }),
                            _vm._v(" "),
                            _c("line", {
                              attrs: {
                                x1: "14",
                                y1: "14",
                                x2: "0",
                                y2: "0",
                                id: "Stroke-430",
                              },
                            }),
                          ]
                        ),
                      ]
                    ),
                  ]
                ),
              ]
            ),
          ]
        ),
        _vm._v(" "),
        _c(
          "p",
          {
            staticClass:
              "cart-product__price font__family--gotham font__weight--medium font__color--gray",
          },
          [
            _vm._v(
              "\n            " +
                _vm._s(_vm.itemPrice) +
                " " +
                _vm._s(_vm.item.currency)
            ),
          ]
        ),
      ]),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }